export interface ReviewEid {
    idproducto: number;
    tituloProducto: string;
    mensaje: string;
    idpersona: number;
    nombreCompleto: string;
    check: boolean;
}

export function GetVoidReviewEid(): ReviewEid {
    return {
        idproducto: 0,
        tituloProducto: "",
        mensaje: "",
        idpersona: 0,
        nombreCompleto: "",
        check: false,
    }
}